<ng-container [formGroup]="$any(controlContainer?.control)">
    <wdx-form-field
        [locked]="formElement?.isLocked"
        [label]="formElement?.label | translateTokenisedString"
        [guidanceText]="formElement?.guidanceText | translateTokenisedString"
        [isSensitive]="formElement?.isSensitive ?? undefined"
        [isRequired]="formElement?.isRequired ?? undefined"
        [labelForId]="selectId"
        [validationErrorMessage]="
            formControl?.touched
                ? (formControl?.errors | validationErrorMessage)
                : ''
        "
        [warningMessage]="warningText"
    >
        <ng-select
            class="select-options-wrap"
            bindLabel="label"
            bindValue="value"
            [attr.data-cy]="'dropdown-' + formElement?.name"
            [multiple]="formElement?.fieldType === FormFieldType.Multiselect"
            [compareWith]="$any(compareOptionToValue)"
            [items]="$any(options$ | ngrxPush)"
            [loading]="loading"
            [labelForId]="selectId"
            [notFoundText]="'NO_ITEMS_FOUND' | translateTokenisedString"
            [readonly]="
                isDisabled ||
                PENDING_CHANGES_LOCK_FIELD.includes(
                    $any(formElement?.pendingChange?.status)
                )
            "
            [formControlName]="$any(formElement?.name)"
        ></ng-select>
    </wdx-form-field>
</ng-container>
